import {gql} from "@apollo/client";

export const GET_JOB_STEP_RUNS = gql`
	query GetJobRuns(
		$jobRunId: Int
		$jobRunStepId: Int
	) {
		jobStepRuns (
			where: { jobRun: { id: { eq: $jobRunId } } and: {id: {eq: $jobRunStepId}} }
		) {
			nodes {
				id
				start,
				finish,
				total,
				failed,
				succeeded,
				cancel
			}
		}
	}
`;
